import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { PHILOSOPHY_GROUPS } from "../data/philosophy";

const MODE_SECTIONS = PHILOSOPHY_GROUPS.find((g) => g.id === "modes").sections;

export default function ModeInfo({ modeId, onClose }) {
  const s = MODE_SECTIONS.find((m) => m.id === modeId);
  return (
    <Dialog open={!!s} onOpenChange={(o) => !o && onClose()}>
      <DialogContent
        className="max-h-[85vh] w-[calc(100%-2rem)] max-w-lg overflow-y-auto rounded-2xl border-white/10 bg-slate-950/90 text-slate-100 backdrop-blur-xl"
        data-testid="mode-info-dialog"
      >
        {s && (
          <>
            <DialogHeader>
              <p className="pr-8 font-mono text-[10px] uppercase tracking-[0.3em] text-cyan-300/70">BreathTones · Mode</p>
              <DialogTitle className="font-serif text-3xl font-normal tracking-wide text-amber-200" data-testid="mode-info-title">
                {s.title}
              </DialogTitle>
              <DialogDescription className="sr-only">How the {s.title} mode works</DialogDescription>
            </DialogHeader>
            <div className="space-y-4" data-testid="mode-info-body">
              {s.paragraphs.map((p, i) => (
                <p key={i} className="font-serif text-lg leading-relaxed text-slate-200">{p}</p>
              ))}
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
